// Main JavaScript
(function() {
    'use strict';
    // Navbar functionality
    function initNavbar() {
        const navbar = document.getElementById('navbar');
        const navToggle = document.querySelector('.nav-toggle');
        const navMenu = document.querySelector('.nav-menu');
        const navLinks = document.querySelectorAll('.nav-link');
        // Scroll effect
        function handleScroll() {
            if (window.scrollY > 50) navbar.classList.add('scrolled');
            else navbar.classList.remove('scrolled');
        }
        // Mobile menu toggle
        if (navToggle) navToggle.addEventListener('click', function() {
            const isExpanded = navToggle.getAttribute('aria-expanded') === 'true';
            navToggle.setAttribute('aria-expanded', !isExpanded);
            navMenu.classList.toggle('active');
        });
        // Close mobile menu when clicking on a link
        navLinks.forEach((link)=>{
            link.addEventListener('click', function() {
                navMenu.classList.remove('active');
                if (navToggle) navToggle.setAttribute('aria-expanded', 'false');
            });
        });
        // Active link on scroll
        function setActiveLink() {
            const sections = document.querySelectorAll('section[id]');
            const scrollY = window.pageYOffset;
            sections.forEach((section)=>{
                const sectionHeight = section.offsetHeight;
                const sectionTop = section.offsetTop - 100;
                const sectionId = section.getAttribute('id');
                const link = document.querySelector(`.nav-link[href="#${sectionId}"]`);
                if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
                    navLinks.forEach((l)=>l.classList.remove('active'));
                    if (link) link.classList.add('active');
                }
            });
        }
        window.addEventListener('scroll', function() {
            handleScroll();
            setActiveLink();
        });
        handleScroll();
        setActiveLink();
    }
    // FAQ Accordion
    function initFAQ() {
        const faqQuestions = document.querySelectorAll('.faq-question');
        faqQuestions.forEach((question)=>{
            question.addEventListener('click', function() {
                const isExpanded = this.getAttribute('aria-expanded') === 'true';
                // Close all other FAQs
                faqQuestions.forEach((q)=>{
                    if (q !== this) q.setAttribute('aria-expanded', 'false');
                });
                // Toggle current FAQ
                this.setAttribute('aria-expanded', !isExpanded);
            });
        });
    }
    // Smooth scroll for anchor links
    function initSmoothScroll() {
        const links = document.querySelectorAll('a[href^="#"]');
        links.forEach((link)=>{
            link.addEventListener('click', function(e) {
                const href = this.getAttribute('href');
                if (href === '#') return;
                const target = document.querySelector(href);
                if (target) {
                    e.preventDefault();
                    const offsetTop = target.offsetTop - 80;
                    window.scrollTo({
                        top: offsetTop,
                        behavior: 'smooth'
                    });
                }
            });
        });
    }
    // Initialize all functions when DOM is ready
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() {
        initNavbar();
        initFAQ();
        initSmoothScroll();
    });
    else {
        initNavbar();
        initFAQ();
        initSmoothScroll();
    }
})();

//# sourceMappingURL=alooshd.com.59c96e09.js.map
